import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './ToggleButton.scss';
import {slugify} from '../../utils/dataQa';

const ToggleButton = props => {
    const {className, isDisabled, label, isChecked, onChange, dataQa} = props;
    const toggleButtonClassName = classnames('ace-c-toggle', {
        'ace-c-toggle--disabled': isDisabled,
    },
    className);

    return (
        <div className={toggleButtonClassName}>
            <label className="ace-c-toggle__button">
                <input
                    type="checkbox"
                    onClick={() => onChange()}
                    checked={isChecked}
                    onChange={() => {}}
                    data-qa={dataQa || `toggle-button-${slugify(label || 'unnamed')}`}
                />
                <span className="ace-c-toggle__slider" />
            </label>
            <span className="ace-c-toggle__label">{label}</span>
        </div>
    );
};

ToggleButton.propTypes = {
    isChecked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    label: PropTypes.string,
    dataQa: PropTypes.string,
};

ToggleButton.defaultProps = {
    isChecked: false,
    className: '',
    isDisabled: false,
    label: '',
    dataQa: '',
};

export default ToggleButton;
